/*==================================================
ALL 4 In Accordian
===================================================*/
// import React, { useEffect, useState } from "react";
// import "./FloatBookingModal.css";
// import { toast } from "react-toastify";
// import Loader from "../../../../Loader/Loader";
// import { AssignPhotographerToBookingAPI, GetToFloatPhotographersgAPI, SortPhotographersAPI } from "../../../../utils/APIs/bookingsApis";

// import { useNavigate } from "react-router-dom";
// import { getServicesAPI } from "../../../../utils/APIs/servicesApis";

// const FloatBookingModal = ({ booking, isOpen, onClose, refetchData }) => {
//     const [photographers, setPhotographers] = useState([]);
//     const [photographerSearch, setPhotographerSearch] = useState("");
//     const [selectAllChecked, setSelectAllChecked] = useState(false);
//     const [loadingPhotographers, setLoadingPhotographers] = useState(false);
//     const [services, setServices] = useState([]);
//     // const photographerDropdownRef = useRef(null);
//     const [filters, setFilters] = useState({
//         rating: "",
//         expertise: "",
//         category: "",
//     });
//     const [isLock, setIsLock] = useState(false);
//     const [isPhotographerAccordionOpen, setIsPhotographerAccordionOpen] = useState(true);
//     const LIMIT = 10;

//     const [page, setPage] = useState(1);
//     const [total, setTotal] = useState(0);
//     console.log("BOOKING", booking)
//     const navigate = useNavigate()
//     const [formData, setFormData] = useState({
//         photographerIds: [],
//     });
//     const [loadingAddBooking, setLoadingAddBooking] = useState(false);
//     const formatDate = (date) => {
//         if (!date) return "-";

//         return new Date(date).toLocaleDateString("en-GB", {
//             day: "2-digit",
//             month: "2-digit",
//             year: "numeric",
//         });
//     };

//     const toCamelCase = (str) => {
//         if (!str) return "";
//         return str
//             .toLowerCase()
//             .replace(/[-_ ]+(.)/g, (_, c) => c.toUpperCase());
//     };

//     const handleSelectAll = async (e) => {
//         const checked = e.target.checked;
//         setSelectAllChecked(checked);

//         if (checked) {
//             try {
//                 const res = await GetToFloatPhotographersgAPI(1, total, booking.bookingId);

//                 const allIds = res?.data?.data?.map((p) => p._id) || [];

//                 setFormData((prev) => ({
//                     ...prev,
//                     photographerIds: allIds,
//                 }));
//             } catch (error) {
//                 console.error("Failed to fetch all photographers", error);
//             }
//         } else {
//             setFormData((prev) => ({
//                 ...prev,
//                 photographerIds: [],
//             }));
//         }
//     };
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             // handle click outside if needed
//         };

//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);
//     useEffect(() => {
//         if (!isOpen) return;

//         fetchPhotographers(page);
//         setSelectAllChecked(false);
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [isOpen, page]);

//     const totalPages = Math.ceil(total / LIMIT);

//     const getPageNumbers = () => {
//         const pages = [];
//         for (let i = 1; i <= totalPages; i++) {
//             pages.push(i);
//         }
//         return pages;
//     };

//     const fetchPhotographers = async (pageNo = page) => {
//         try {
//             setLoadingPhotographers(true);

//             let res;

//             // ✅ If any filter is applied → use SORT API
//             if (filters.rating || filters.expertise || filters.category) {
//                 res = await SortPhotographersAPI(filters, pageNo, LIMIT, booking.bookingId);
//                 setPhotographers(res?.data?.data || []);
//                 setTotal(res?.data?.meta?.total || res?.data?.data?.length || 0);
//                 setPage(res?.data?.meta?.page || pageNo);
//                 setIsLock(res?.data?.isLock || false);
//             } else {
//                 // ✅ Default list (paginated)
//                 res = await GetToFloatPhotographersgAPI(pageNo, LIMIT, booking.bookingId);
//                 setPhotographers(res?.data?.data || []);
//                 setTotal(res?.data?.meta?.total || 0);
//                 setPage(res?.data?.meta?.page || pageNo);
//                 setIsLock(res?.data?.isLock || false);
//             }

//         } catch (error) {
//             console.error("Photographer fetch failed", error);
//         } finally {
//             setLoadingPhotographers(false);
//         }
//     };

//     useEffect(() => {
//         if (!isOpen) return;
//         fetchPhotographers(1);
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [filters, isOpen,]);

//     useEffect(() => {
//         if (!isOpen) return;

//         const fetchServices = async () => {
//             try {
//                 const res = await getServicesAPI();
//                 setServices(res?.data?.data || []);
//             } catch (err) {
//                 console.error("Failed to fetch services", err);
//             }
//         };

//         fetchServices();
//     }, [isOpen]);

//     if (!isOpen) return null;

//     const filteredPhotographers = (photographers || []).filter((p) =>
//         p.name?.toLowerCase().includes(photographerSearch.toLowerCase()) ||
//         (p.mobileNumber || p.phone)?.includes(photographerSearch)
//     );

//     const resetForm = () => {
//         setFormData({
//             photographerIds: [],
//         });

//         setSelectAllChecked(false);
//         setPhotographerSearch("");
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (formData.photographerIds.length === 0) {
//             toast.error("Please select at least one photographer");
//             return;
//         }

//         try {
//             setLoadingAddBooking(true);

//             let payload = {
//                 bookingId: booking.bookingId,
//             };

//             if (formData.photographerIds.length === 1) {
//                 payload.photographerId = formData.photographerIds[0];
//             } else {
//                 payload.photographerIds = formData.photographerIds;
//             }

//             const response = await AssignPhotographerToBookingAPI(payload);

//             if (response?.data?.success) {
//                 toast.success(
//                     response?.data?.message ||
//                     "Photographer request sent successfully!"
//                 );

//                 refetchData();
//                 resetForm();
//                 onClose();
//             } else {
//                 toast.error(response?.data?.message || "Failed to send request!");
//             }
//         } catch (error) {
//             console.error("Assign Booking Error:", error);
//             toast.error("Something went wrong");
//         } finally {
//             setLoadingAddBooking(false);
//         }
//     };
    
//     if (loadingAddBooking) {
//         return <Loader />
//     }
    
//     return (
//         <div className="float-photographer-modal-overlay">
//             <div className="float-photographer-modal-container">

//                 <div className="float-photographer-modal-header">
//                     <h3>Float booking </h3>

//                     <div className="booking-info-grid">
//                         <div className="booking-info-item">
//                             <span>Booking ID</span>
//                             <p>{booking?.veroaBookingId || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Amount</span>
//                             <p>₹ {booking?.bookingAmount || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Event Type</span>
//                             <p>{booking?.eventType || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Location</span>
//                             <p>{booking?.location || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Start Date</span>
//                             <p>
//                                 {formatDate(booking.startDate) || "-"}
//                             </p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>End Date</span>
//                             <p>
//                                 {formatDate(booking.endDate) || "-"}
//                             </p>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="assign-photographer-modal-body">
//                     <form id="floatForm" onSubmit={handleSubmit} className="assign-photographer-form">

//                         {/* Photographer Accordion */}
//                         <div className="form-group" style={{ gridColumn: "span 2" }}>
//                             <div 
//                                 className="accordion-header"
//                                 onClick={() => setIsPhotographerAccordionOpen(!isPhotographerAccordionOpen)}
//                                 style={{
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     alignItems: 'center',
//                                     cursor: 'pointer',
//                                     padding: '12px',
//                                     backgroundColor: 'var(--color-bg-secondary)',
//                                     borderRadius: '8px',
//                                     marginBottom: isPhotographerAccordionOpen ? '16px' : '0',
//                                     border: '1px solid #e5e7eb'
//                                 }}
//                             >
//                                 <label style={{ fontWeight: '600', margin: 0, cursor: 'pointer' }}>
//                                   Photographers
//                                 </label>
//                                 <span style={{ fontSize: '20px', transition: 'transform 0.3s' }}>
//                                     {isPhotographerAccordionOpen ? '▲' : '▼'}
//                                 </span>
//                             </div>

//                             {isPhotographerAccordionOpen && (
//                                 <div className="photographer-accordion-content">
//                                      <label style={{ fontWeight: '600', margin: 0, cursor: 'pointer' }}>
//                                     Select Photographers *
//                                 </label>
//                                     {/* Search Bar */}
//                                     <div className="search-bar-container" style={{ marginBottom: '16px' }}>
//                                         <input
//                                             type="text"
//                                             className="photographer-search-input"
//                                             placeholder="Search Photographer by name"
//                                             value={photographerSearch}
//                                             onChange={(e) => {
//                                                 setPhotographerSearch(e.target.value);
//                                                 setPage(1); // Reset to first page on search
//                                             }}
//                                             disabled={isLock}
//                                             style={{
//                                                 width: '100%',
//                                                 padding: '10px 12px',
//                                                 border: '1px solid #dcdcdc',
//                                                 borderRadius: '6px',
//                                                 fontSize: '14px',
//                                                 outline: 'none'
//                                             }}
//                                         />
//                                     </div>

//                                     {/* Filters */}
//                                     <div className="filter-container">
//                                         {/* Rating */}
//                                         <div className="filter-item">
//                                             <label>Rating</label>
//                                             <select
//                                                 value={filters.rating}
//                                                 onChange={(e) =>
//                                                     setFilters({ ...filters, rating: e.target.value })
//                                                 }
//                                                 disabled={isLock}
//                                             >
//                                                 <option value="">All</option>
//                                                 <option value="5">⭐ 5</option>
//                                                 <option value="4">⭐ 4</option>
//                                                 <option value="3">⭐ 3</option>
//                                                 <option value="2">⭐ 2</option>
//                                                 <option value="1">⭐ 1</option>
//                                             </select>
//                                         </div>

//                                         {/* Category */}
//                                         <div className="filter-item">
//                                             <label>Category</label>
//                                             <select
//                                                 value={filters.category}
//                                                 onChange={(e) =>
//                                                     setFilters({ ...filters, category: e.target.value })
//                                                 }
//                                                 disabled={isLock}
//                                             >
//                                                 <option value="">All</option>
//                                                 {services.map((service) => (
//                                                     <option key={service._id} value={toCamelCase(service.serviceName || service.key)}>
//                                                         {service.serviceName}
//                                                     </option>
//                                                 ))}
//                                             </select>
//                                         </div>

//                                         {/* Expertise */}
//                                         <div className="filter-item">
//                                             <label>Expertise</label>
//                                             <select
//                                                 value={filters.expertise}
//                                                 onChange={(e) =>
//                                                     setFilters({ ...filters, expertise: e.target.value })
//                                                 }
//                                                 disabled={isLock}
//                                             >
//                                                 <option value="">All</option>
//                                                 <option value="initio">INITIO</option>
//                                                 <option value="elite">ELITE</option>
//                                                 <option value="pro">PRO</option>
//                                             </select>
//                                         </div>

//                                         {/* Reset */}
//                                         <div className="filter-actions">
//                                             <button
//                                                 type="button"
//                                                 className="btn-reset"
//                                                 onClick={() => {
//                                                     setFilters({ rating: "", expertise: "", category: "" });
//                                                     setPhotographerSearch("");
//                                                     setPage(1);
//                                                 }}
//                                                 disabled={isLock}
//                                             >
//                                                 Reset All
//                                             </button>
//                                         </div>
//                                     </div>

//                                     {/* Photographer Table */}
//                                     <div className="assign-photographer-dropdown-list">
//                                         {loadingPhotographers ? (
//                                             <div className="dropdown-status">Loading photographers...</div>
//                                         ) : filteredPhotographers.length === 0 ? (
//                                             <div className="dropdown-empty">
//                                                 <p>No photographer found</p>
//                                                 <button
//                                                     type="button"
//                                                     className="btn-primary"
//                                                     onClick={() => {
//                                                         navigate("/photographer");
//                                                     }}
//                                                 >
//                                                     + Add New Photographer
//                                                 </button>
//                                             </div>
//                                         ) : (
//                                             <>
//                                                 <div className="table-responsive" style={{ overflowX: 'auto' }}>
//                                                     <table className="photographer-table">
//                                                         <thead>
//                                                             <tr>
//                                                                 <th style={{ width: '80px' }}>
//                                                                     <div className="checkbox-sr-header">
//                                                                         <input
//                                                                             type="checkbox"
//                                                                             onChange={handleSelectAll}
//                                                                             checked={selectAllChecked && filteredPhotographers.length > 0 && 
//                                                                                 filteredPhotographers.every(p => formData.photographerIds.includes(p._id))}
//                                                                             disabled={isLock}
//                                                                         />
//                                                                         <span>Sr.</span>
//                                                                     </div>
//                                                                 </th>
//                                                                 <th>Photographer Name</th>
//                                                                 <th>Category</th>
//                                                                 <th>Level</th>
//                                                                 <th>Commission</th>
//                                                                 <th>Avg. Rating</th>
//                                                             </tr>
//                                                         </thead>
//                                                         <tbody>
//                                                             {filteredPhotographers.map((photographer, index) => {
//                                                                 const isChecked = formData.photographerIds.includes(photographer._id);
//                                                                 const disableRow = formData.photographerIds.length === 1 && !isChecked && !selectAllChecked;
//                                                                 return (
//                                                                     <tr key={photographer._id}>
//                                                                         <td>
//                                                                             <div className="checkbox-sr-cell">
//                                                                                 <input
//                                                                                     type="checkbox"
//                                                                                     checked={isChecked || photographer.isAssigned}
//                                                                                     disabled={isLock || photographer.isAssigned || disableRow}
//                                                                                     onChange={(e) => {
//                                                                                         const checked = e.target.checked;
//                                                                                         setFormData((prev) => ({
//                                                                                             ...prev,
//                                                                                             photographerIds: checked
//                                                                                                 ? [...prev.photographerIds, photographer._id]
//                                                                                                 : prev.photographerIds.filter((id) => id !== photographer._id),
//                                                                                         }));
//                                                                                         // Reset select all when manually changing
//                                                                                         if (selectAllChecked) setSelectAllChecked(false);
//                                                                                     }}
//                                                                                 />
//                                                                                 <span>{(page - 1) * LIMIT + index + 1}</span>
//                                                                             </div>
//                                                                         </td>
import React, { useEffect, useRef, useState } from "react";
import "./FloatBookingModal.css";
import { toast } from "react-toastify";
import Loader from "../../../../Loader/Loader";
import { AssignPhotographerToBookingAPI, SortPhotographersAPI } from "../../../../utils/APIs/bookingsApis";
import {
    GetToFloatPhotographersgAPI,
    GetToFloatVideographersAPI,
    GetToFloatEditorAPI,
    GetToFloatLightingSetupAPI,
} from "../../../../utils/APIs/hourlyAndEditingBookingsApis";

import { useNavigate } from "react-router-dom";
import { getServicesAPI } from "../../../../utils/APIs/servicesApis";
import { resolveBookingRequirementText } from "../../../../utils/viewDetailsBuilders";
import {
    getFloatStaffRole,
    shouldShowFloatRequirement,
} from "../../UpcomingHourlyComponent/UpcomingHourlyBookingTable/HourlyFloatBookingModal/hourlyFloatHelpers";

const getRoleFloatConfig = (booking) => {
    const role = getFloatStaffRole(booking);
    if (role.roleKey === "videographer") {
        return { photographerType: "Videographer", listApi: "videographer" };
    }
    if (role.roleKey === "editor") {
        return { photographerType: "Editor", listApi: "editor" };
    }
    if (role.roleKey === "lightingSetup") {
        return { photographerType: "Lighting Setup", listApi: "lighting" };
    }
    return { photographerType: "Photographer", listApi: "photographer" };
};

const matchesExpectedProfessionalType = (person, expectedType) => {
    if (!expectedType) return true;
    const actual = (person?.photographerType || "").trim();
    const expected = expectedType.trim();

    if (expected === "Photographer") {
        return !["Videographer", "Editor", "Lighting Setup"].includes(actual);
    }
    if (expected === "Videographer") {
        return actual === "Videographer";
    }
    if (expected === "Editor") {
        return actual === "Editor";
    }
    if (expected === "Lighting Setup") {
        return actual === "Lighting Setup" || /drone/i.test(actual);
    }
    return actual.toLowerCase() === expected.toLowerCase();
};

const normalizeProfessionalId = (id) => String(id ?? "");

const FloatBookingModal = ({ booking, isOpen, onClose, refetchData }) => {
    const [photographers, setPhotographers] = useState([]);
    const [photographerSearch, setPhotographerSearch] = useState("");
    const [selectAllChecked, setSelectAllChecked] = useState(false);
    const [loadingPhotographers, setLoadingPhotographers] = useState(false);
    const [services, setServices] = useState([]);
    const photographerDropdownRef = useRef(null);
    const [filters, setFilters] = useState({
        rating: "",
        expertise: "",
        category: "",
    });
    const [isLock, setIsLock] = useState(false);
    const [photographerOverrides, setPhotographerOverrides] = useState({});
    const LIMIT = 10;

    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    console.log("BOOKING", booking)
    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        photographerIds: [],
    });
    const [loadingAddBooking, setLoadingAddBooking] = useState(false);

    const staffRole = getFloatStaffRole(booking);
    const displayRole = staffRole.displayTitle || "Photographers";

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [isOpen]);

    const getBaseAmount = () => {
        const total = parseFloat(
            booking?.finalAmount || booking?.bookingAmount || booking?.totalAmount || 0
        );
        return Math.round(Number.isNaN(total) ? 0 : total);
    };

    const calcPayoutFromCommission = (commissionPct, gstRegistered) => {
        const base = getBaseAmount();
        const pct = parseFloat(commissionPct);
        if (Number.isNaN(pct) || pct < 0 || pct > 100 || base <= 0) return "";
        const veroCommission = base * (pct / 100);
        if (gstRegistered) {
            return Math.round(base - veroCommission);
        }
        return Math.round(base / 1.18 - veroCommission);
    };

    const calcAmountFromCommission = (commissionPct, gstRegistered = false) =>
        calcPayoutFromCommission(commissionPct, gstRegistered);

    const calcCommissionFromAmount = (amount, gstRegistered = false) => {
        const base = getBaseAmount();
        const amt = parseFloat(amount);
        if (Number.isNaN(amt) || base <= 0 || amt < 0) return "";
        const effectiveBase = gstRegistered ? base : base / 1.18;
        if (amt > effectiveBase) return "";
        return parseFloat(((1 - amt / effectiveBase) * 100).toFixed(2));
    };

    const getCommission = (photographer) => {
        const override = photographerOverrides[photographer._id];
        if (override?.commission !== undefined) return override.commission;
        return photographer.commissionPercentage ?? "";
    };

    const getPhotographerAmount = (photographer) => {
        const override = photographerOverrides[photographer._id];
        if (override?.amount !== undefined) return override.amount;
        const commission = getCommission(photographer);
        if (commission === undefined || commission === null || commission === "") return "";
        const payout = calcPayoutFromCommission(commission, photographer?.gstRegistered);
        return payout !== "" ? String(payout) : "";
    };

    const handleCommissionChange = (photographerId, value, gstRegistered = false) => {
        const amount =
            value !== "" ? calcAmountFromCommission(value, gstRegistered) : "";
        setPhotographerOverrides((prev) => ({
            ...prev,
            [photographerId]: { commission: value, amount: amount !== "" ? String(amount) : "" },
        }));
    };

    const handleAmountChange = (photographerId, value, gstRegistered = false) => {
        const commission =
            value !== "" ? calcCommissionFromAmount(value, gstRegistered) : "";
        setPhotographerOverrides((prev) => ({
            ...prev,
            [photographerId]: { amount: value, commission: commission !== "" ? String(commission) : "" },
        }));
    };

    const buildPhotographerDetailsPayload = () => {
        const photographerById = new Map(
            photographers.map((p) => [normalizeProfessionalId(p._id), p])
        );

        return formData.photographerIds.map((id) => {
            const rowId = normalizeProfessionalId(id);
            const p = photographerById.get(rowId) || {};
            const commission =
                photographerOverrides[rowId]?.commission !== undefined
                    ? photographerOverrides[rowId].commission
                    : (p.commissionPercentage ?? "");
            const amount =
                photographerOverrides[rowId]?.amount !== undefined
                    ? String(photographerOverrides[rowId].amount)
                    : String(calcPayoutFromCommission(commission, p.gstRegistered) || "");

            return {
                photographerId: rowId,
                amount,
                commission: String(commission ?? ""),
                roleKey: staffRole.roleKey || "photographer",
            };
        });
    };

    const formatDate = (date) => {
        if (!date) return "-";

        return new Date(date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };

    const toCamelCase = (str) => {
        if (!str) return "";
        return str
            .toLowerCase()
            .replace(/[-_ ]+(.)/g, (_, c) => c.toUpperCase());
    };

    const fetchProfessionalsForRole = async (pageNo, limitOverride = LIMIT) => {
        const roleConfig = getRoleFloatConfig(booking);
        const activeTypeFilter = filters.photographerType || roleConfig.photographerType;
        const sortFilters = {
            ...filters,
            photographerType: activeTypeFilter,
        };
        const hasExtraSortFilters = !!(filters.rating || filters.expertise || filters.category);

        let res;
        if (hasExtraSortFilters) {
            res = await SortPhotographersAPI(sortFilters, pageNo, limitOverride, booking.bookingId);
        } else {
            switch (roleConfig.listApi) {
                case "videographer":
                    res = await GetToFloatVideographersAPI(pageNo, limitOverride, booking.bookingId);
                    break;
                case "editor":
                    res = await GetToFloatEditorAPI(pageNo, limitOverride, booking.bookingId);
                    break;
                case "lighting":
                    res = await GetToFloatLightingSetupAPI(pageNo, limitOverride, booking.bookingId);
                    break;
                default:
                    res = await GetToFloatPhotographersgAPI(pageNo, limitOverride, booking.bookingId);
            }
        }

        const rows = (res?.data?.data || []).filter((person) =>
            matchesExpectedProfessionalType(person, activeTypeFilter)
        );

        return { rows, meta: res?.data?.meta, isLock: res?.data?.isLock };
    };

    const handleSelectAll = async (e) => {
        const checked = e.target.checked;
        setSelectAllChecked(checked);

        if (checked) {
            try {
                const fetchTotal = total > 0 ? total : LIMIT;
                const { rows } = await fetchProfessionalsForRole(1, fetchTotal);
                const allIds = rows
                    .filter((p) => !(p.isAssigned && !p.isInvited))
                    .filter((p) => p.status?.toLowerCase() !== "inactive" && p.isActive !== false)
                    .map((p) => normalizeProfessionalId(p._id));

                setFormData((prev) => ({
                    ...prev,
                    photographerIds: allIds,
                }));
            } catch (error) {
                console.error("Failed to fetch all professionals", error);
                setSelectAllChecked(false);
            }
        } else {
            setFormData((prev) => ({
                ...prev,
                photographerIds: [],
            }));
        }
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    useEffect(() => {
        if (!isOpen) return;

        fetchPhotographers(page);
        setSelectAllChecked(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, page]);

    useEffect(() => {
        if (!isOpen || !booking) return;

        const roleConfig = getRoleFloatConfig(booking);
        setFilters((prev) => ({
            ...prev,
            photographerType: roleConfig.photographerType,
        }));
    }, [isOpen, booking]);

    const totalPages = Math.ceil(total / LIMIT);

    const getPageNumbers = () => {
        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
        return pages;
    };

    const fetchPhotographers = async (pageNo = page) => {
        try {
            setLoadingPhotographers(true);
            const { rows, meta, isLock: lockFromApi } = await fetchProfessionalsForRole(pageNo, LIMIT);

            setPhotographers(rows);
            setTotal(meta?.total ?? rows.length);
            setPage(meta?.page || pageNo);
            setIsLock(lockFromApi || false);
        } catch (error) {
            console.error("Photographer fetch failed", error);
        } finally {
            setLoadingPhotographers(false);
        }
    };

    useEffect(() => {
        if (!isOpen) return;
        setSelectAllChecked(false);
        fetchPhotographers(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters, isOpen,]);

    useEffect(() => {
        if (!isOpen) return;

        const fetchServices = async () => {
            try {
                const res = await getServicesAPI();
                setServices(res?.data?.data || []);
            } catch (err) {
                console.error("Failed to fetch services", err);
            }
        };

        fetchServices();
    }, [isOpen]);



    if (!isOpen) return null;


    const filteredPhotographers = (photographers || []).filter((p) =>
        p.name?.toLowerCase().includes(photographerSearch.toLowerCase()) ||
        (p.mobileNumber || p.phone)?.includes(photographerSearch)
    );




    const resetForm = () => {
        setFormData({
            photographerIds: [],
        });

        setSelectAllChecked(false);
        setPhotographerSearch("");
        setPhotographerOverrides({});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.photographerIds.length === 0) {
            toast.error("Please select at least one photographer");
            return;
        }

        try {
            setLoadingAddBooking(true);

            const photographerDetails = buildPhotographerDetailsPayload();

            const resolvedRoleKey = staffRole.roleKey || "photographer";

            let payload = {
                bookingId: booking.bookingId || booking.veroaBookingId,
                photographerDetails,
                actionType: "request",
                packageIndex: 0,
                roleSelections: {
                    [resolvedRoleKey]: formData.photographerIds,
                },
            };

            if (formData.photographerIds.length === 1) {
                payload.photographerId = formData.photographerIds[0];
            } else {
                payload.photographerIds = formData.photographerIds;
            }

            const response = await AssignPhotographerToBookingAPI(payload);

            if (response?.data?.success) {
                toast.success(
                    response?.data?.message ||
                    "Photographer request sent successfully!"
                );

                refetchData();
                resetForm();
                onClose();
            } else {
                toast.error(response?.data?.message || "Failed to send request!");
            }
        } catch (error) {
            console.error("Assign Booking Error:", error);
            toast.error("Something went wrong");
        } finally {
            setLoadingAddBooking(false);
        }
    };
    if (loadingAddBooking) {
        return <Loader />
    }

    const showRequirement = shouldShowFloatRequirement(booking);

    return (
        <div className="float-photographer-modal-overlay">
            <div className="float-photographer-modal-container">

                <div className="float-photographer-modal-header">
                    <h3>Float booking </h3>

                    <div className="booking-info-grid">
                        <div className="booking-info-item">
                            <span>Booking ID</span>
                            <p>{booking?.veroaBookingId || "-"}</p>
                        </div>

                        <div className="booking-info-item">
                            <span>Total Amount</span>
                            <p>₹ {booking?.finalAmount || booking?.totalAmount || booking?.bookingAmount || "-"}</p>
                        </div>

                        <div className="booking-info-item">
                            <span>Event Type</span>
                            <p>{booking?.eventType || "-"}</p>
                        </div>

                        <div className="booking-info-item">
                            <span>Location</span>
                            <p>{booking?.location || "-"}</p>
                        </div>

                        <div className="booking-info-item">
                            <span>Start Date</span>
                            <p>
                                {formatDate(booking.startDate) || "-"}
                            </p>
                        </div>

                        <div className="booking-info-item">
                            <span>End Date</span>
                            <p>
                                {formatDate(booking.endDate) || "-"}
                            </p>
                        </div>

                        {showRequirement &&
                        resolveBookingRequirementText(booking) ? (
                            <div className="booking-info-item">
                                <span>Requirement</span>
                                <p>{resolveBookingRequirementText(booking)}</p>
                            </div>
                        ) : null}

                    </div>
                </div>

                <div className="assign-photographer-modal-body">
                    <form id="floatForm" onSubmit={handleSubmit} className="assign-photographer-form">



                        <div className="form-group" style={{ gridColumn: "span 2" }}>
                            <label>Float {displayRole} *</label>

                            <div className="user-dropdown" ref={photographerDropdownRef}>
                                <div className="dropdown-input-wrapper">
                                    <input
                                        type="text"
                                        placeholder={`Search ${displayRole} by name`}
                                        value={photographerSearch}
                                        onChange={(e) => {
                                            setPhotographerSearch(e.target.value);
                                        }}
                                        disabled={isLock}
                                    />
                                    <span className="dropdown-arrow">▼</span>
                                </div>


                                <div className="filter-container">
                                    <div className="filter-item">
                                        <label>Rating</label>
                                        <select
                                            className="float-filter-select"
                                            value={filters.rating}
                                            onChange={(e) =>
                                                setFilters({ ...filters, rating: e.target.value })
                                            }
                                            disabled={isLock}
                                        >
                                            <option value="">All</option>
                                            <option value="5">5 stars</option>
                                            <option value="4">4 stars</option>
                                            <option value="3">3 stars</option>
                                            <option value="2">2 stars</option>
                                            <option value="1">1 star</option>
                                        </select>
                                    </div>

                                    <div className="filter-item">
                                        <label>Category</label>
                                        <select
                                            className="float-filter-select"
                                            value={filters.category}
                                            onChange={(e) =>
                                                setFilters({ ...filters, category: e.target.value })
                                            }
                                            disabled={isLock}
                                        >
                                            <option value="">All</option>

                                            {services.map((service) => (
                                                <option key={service._id} value={toCamelCase(service.serviceName || service.key)}>
                                                    {service.serviceName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="filter-item">
                                        <label>Expertise</label>
                                        <select
                                            className="float-filter-select"
                                            value={filters.expertise}
                                            onChange={(e) =>
                                                setFilters({ ...filters, expertise: e.target.value })
                                            }
                                            disabled={isLock}
                                        >
                                            <option value="">All</option>
                                            <option value="initio">INITIO</option>
                                            <option value="elite">ELITE</option>
                                            <option value="pro">PRO</option>
                                        </select>
                                    </div>



                                    <div className="filter-actions">
                                        <button
                                            type="button"
                                            className="btn-reset"
                                            onClick={() =>
                                                setFilters({ rating: "", expertise: "", category: "" })
                                            }
                                            disabled={isLock}
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                                <div className="assign-photographer-dropdown-list">
                                    {loadingPhotographers ? (
                                        <div className="dropdown-status">Loading photographers...</div>
                                    ) : filteredPhotographers.length === 0 ? (
                                        <div className="dropdown-empty">
                                            <p>No {displayRole.toLowerCase()} found</p>
                                            <button
                                                type="button"
                                                className="btn-primary"
                                                onClick={() => {
                                                    navigate("/photographer");
                                                }}
                                            >
                                                + Add New {displayRole}
                                            </button>
                                        </div>
                                    ) : (
                                        <table className="photographer-table">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <div className="checkbox-sr-header">
                                                            <input
                                                                type="checkbox"
                                                                onChange={handleSelectAll}
                                                                checked={selectAllChecked}
                                                                disabled={isLock || filteredPhotographers.some(p => p.isAssigned && !p.isInvited)}
                                                            />
                                                            <span>Sr.</span>
                                                        </div>
                                                    </th>

                                                    <th>{booking?.quoteType === "Hourly Quote" ? displayRole : "Photographer"} Name</th>
                                                    <th>Category</th>
                                                    <th>Level</th>
                                                    <th>Commission %</th>
                                                    <th>{booking?.quoteType === "Hourly Quote" ? displayRole : "Photographer"} Amount (₹)</th>
                                                    <th>Avg. Rating</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {filteredPhotographers.map((photographer, index) => {
                                                    const isChecked = formData.photographerIds
                                                        .map(normalizeProfessionalId)
                                                        .includes(normalizeProfessionalId(photographer._id));
                                                    const isConfirmed = photographer.isAssigned && !photographer.isInvited;
                                                    const commissionVal = getCommission(photographer);
                                                    const amountVal = getPhotographerAmount(photographer);
                                                    return (
                                                        <tr key={photographer._id}>
                                                            <td>
                                                                <div className="checkbox-sr-cell">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={isChecked || isConfirmed}
                                                                        disabled={isLock || isConfirmed}
                                                                        onChange={(e) => {
                                                                            if (e.target.checked && (photographer.status?.toLowerCase() === 'inactive' || photographer.isActive === false)) {
                                                                                toast.error("This photographer is inactive");
                                                                                e.preventDefault();
                                                                                return;
                                                                            }
                                                                            const checked = e.target.checked;
                                                                            if (selectAllChecked) setSelectAllChecked(false);
                                                                            const rowId = normalizeProfessionalId(photographer._id);
                                                                            setFormData((prev) => ({
                                                                                ...prev,
                                                                                photographerIds: checked
                                                                                    ? [...prev.photographerIds, rowId]
                                                                                    : prev.photographerIds.filter(
                                                                                          (id) => normalizeProfessionalId(id) !== rowId
                                                                                      ),
                                                                            }));
                                                                        }}
                                                                    />
                                                                    <span> {(page - 1) * LIMIT + index + 1}</span>
                                                                </div>
                                                            </td>

                                                            <td>{photographer.name || "-"}</td>
                                                            <td>
                                                                {photographer.categories?.length > 0
                                                                    ? photographer.categories.join(", ")
                                                                    : "-"}
                                                            </td>
                                                            <td>{photographer.level || photographer.expertiseLevel || "-"}</td>

                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    className="amount-input"
                                                                    value={commissionVal}
                                                                    min="0"
                                                                    max="100"
                                                                    step="0.01"
                                                                    placeholder="-"
                                                                    disabled={isLock}
                                                                    onChange={(e) => handleCommissionChange(photographer._id, e.target.value, photographer.gstRegistered)}
                                                                    style={{ width: "80px" }}
                                                                />
                                                                <span style={{ marginLeft: "4px", fontSize: "12px", color: "#666" }}>%</span>
                                                            </td>

                                                            <td>
                                                                <span style={{ marginRight: "4px", fontSize: "12px", color: "#666" }}>₹</span>
                                                                <input
                                                                    type="number"
                                                                    className="amount-input"
                                                                    value={amountVal}
                                                                    min="0"
                                                                    step="1"
                                                                    placeholder="-"
                                                                    disabled={isLock}
                                                                    onChange={(e) => handleAmountChange(photographer._id, e.target.value, photographer.gstRegistered)}
                                                                    style={{ width: "100px" }}
                                                                />
                                                            </td>

                                                            <td>
                                                                {photographer.avgRating != null
                                                                    ? `⭐ ${Number(photographer.avgRating).toFixed(1)}`
                                                                    : "-"}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    )}
                                    {totalPages > 1 && filteredPhotographers.length > 0 && (
                                        <div className="pagination">
                                            <button
                                                type="button"
                                                className="pagination-btn"
                                                disabled={page === 1}
                                                onClick={() => setPage(page - 1)}
                                            >
                                                Prev
                                            </button>

                                            {getPageNumbers().map((p) => (
                                                <button
                                                    type="button"
                                                    key={p}
                                                    className={`pagination-btn ${p === page ? "active" : ""}`}
                                                    onClick={() => setPage(p)}
                                                >
                                                    {p}
                                                </button>
                                            ))}

                                            <button
                                                type="button"
                                                className="pagination-btn"
                                                disabled={page === totalPages}
                                                onClick={() => setPage(page + 1)}
                                            >
                                                Next
                                            </button>
                                        </div>
                                    )}
                                </div>

                            </div>

                        </div>





                    </form>
                </div>

                <div className="quote-modal-footer">
                    <button className="btn-secondary" type="button"
                        onClick={() => {
                            resetForm();
                            onClose();
                        }}>
                        Cancel
                    </button>
                    <button className="btn-primary" type="submit" form="floatForm" disabled={isLock}>
                        Send Request
                    </button>
                </div>

            </div>
        </div>
    );
};

export default FloatBookingModal;



//=============================================================
//PARTIALLY SELECT

// import React, { useEffect, useRef, useState } from "react";
// import "./FloatBookingModal.css";
// import { toast } from "react-toastify";
// import Loader from "../../../../Loader/Loader";
// import { AssignPhotographerToBookingAPI, GetToFloatPhotographersgAPI } from "../../../../utils/APIs/bookingsApis";
// import { getVerifiedPhotographersAPI } from "../../../../utils/APIs/photographersApis";
// import { useNavigate } from "react-router-dom";

// const FloatBookingModal = ({ booking, isOpen, onClose, refetchData }) => {
//     const [photographers, setPhotographers] = useState([]);
//     const [photographerSearch, setPhotographerSearch] = useState("");
//     const [photographerDropdownOpen,setIsPhotographerDropdownOpen] = useState(false);
//     const [allPhotographerIds, setAllPhotographerIds] = useState([]);
//     const [selectAllChecked, setSelectAllChecked] = useState(false);
//     const [loadingPhotographers, setLoadingPhotographers] = useState(false);
//     const photographerDropdownRef = useRef(null);
//     // const [requirements, setRequirements] = useState([]);
//     const LIMIT = 10;

//     const [page, setPage] = useState(1);
//     const [total, setTotal] = useState(0);
//     console.log("BOOKING", booking)
//     const navigate = useNavigate()
//     const [formData, setFormData] = useState({
//         photographerIds: [],
//     });
//     const [loadingAddBooking, setLoadingAddBooking] = useState(false);
//     const formatDate = (date) => {
//         if (!date) return "-";

//         return new Date(date).toLocaleDateString("en-GB", {
//             day: "2-digit",
//             month: "2-digit",
//             year: "numeric",
//         });
//     };

//    const handleSelectAll = async (e) => {
//     const checked = e.target.checked;
//     setSelectAllChecked(checked);

//     if (checked) {
//         try {
//             const res = await GetToFloatPhotographersgAPI(1, total);

//             const allIds = res?.data?.data?.map((p) => p._id) || [];

//             setFormData((prev) => ({
//                 ...prev,
//                 photographerIds: allIds,
//             }));
//         } catch (error) {
//             console.error("Failed to fetch all photographers", error);
//         }
//     } else {
//         setFormData((prev) => ({
//             ...prev,
//             photographerIds: [],
//         }));
//     }
// };
//     useEffect(() => {
//         const handleClickOutside = (event) => {

//             if (
//                 photographerDropdownRef.current &&
//                 !photographerDropdownRef.current.contains(event.target)
//             ) {
//                 setIsPhotographerDropdownOpen(false);
//             }
//         };

//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);
//     useEffect(() => {
//         if (!isOpen) return;

//         fetchPhotographers(page);
//         setSelectAllChecked(false);
//     }, [isOpen, page]);

//     const totalPages = Math.ceil(total / LIMIT);

//     const getPageNumbers = () => {
//         const pages = [];
//         for (let i = 1; i <= totalPages; i++) {
//             pages.push(i);
//         }
//         return pages;
//     };

//     const fetchPhotographers = async (pageNo = page) => {
//         try {
//             setLoadingPhotographers(true);

//             const res = await GetToFloatPhotographersgAPI(pageNo, LIMIT);

//             setPhotographers(res?.data?.data || []);
//             setTotal(res?.data?.meta?.total || 0);
//             setPage(res?.data?.meta?.page || pageNo);
//                 // store ids
//         const ids = res?.data?.data?.map((p) => p._id);
//         setAllPhotographerIds((prev) => [...new Set([...prev, ...ids])]);

//         } catch (error) {
//             console.error("Photographer fetch failed", error);
//         } finally {
//             setLoadingPhotographers(false);
//         }
//     };



//     if (!isOpen) return null;


//     const filteredPhotographers = photographers.filter((p) =>
//         p.name?.toLowerCase().includes(photographerSearch.toLowerCase()) ||
//         p.mobileNumber?.includes(photographerSearch)
//     );

//     const resetForm = () => {
//         setFormData({
//             photographerIds: [],
//         });

//         setSelectAllChecked(false);
//         setPhotographerSearch("");
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (formData.photographerIds.length === 0) {
//             toast.error("Please select at least one photographer");
//             return;
//         }

//         try {
//             setLoadingAddBooking(true);

//             const payload = {
//                 bookingId: booking.bookingId,
//                 photographerIds: formData.photographerIds,
//             };

//             const response = await AssignPhotographerToBookingAPI(payload);

//             if (response?.data?.success) {
//                 toast.success(
//                     response?.data?.message ||
//                     "Photographer request sent successfully!"
//                 );

//                 refetchData();
//                 resetForm();
//                 onClose();
//             } else {
//                 toast.error(response?.data?.message || "Failed to send request!");
//             }
//         } catch (error) {
//             console.error("Assign Booking Error:", error);
//             toast.error("Something went wrong");
//         } finally {
//             setLoadingAddBooking(false);
//         }
//     };
//     if (loadingAddBooking) {
//         return <Loader />
//     }
//     return (
//         <div className="float-photographer-modal-overlay">
//             <div className="float-photographer-modal-container">

//                 <div className="float-photographer-modal-header">
//                     <h3>Float booking </h3>

//                     <div className="booking-info-grid">
//                         <div className="booking-info-item">
//                             <span>Booking ID</span>
//                             <p>{booking?.veroaBookingId || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Amount</span>
//                             <p>₹ {booking?.bookingAmount || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Event Type</span>
//                             <p>{booking?.eventType || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Location</span>
//                             <p>{booking?.location || "-"}</p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>Start Date</span>
//                             <p>
//                                 {formatDate(booking.startDate) || "-"}
//                             </p>
//                         </div>

//                         <div className="booking-info-item">
//                             <span>End Date</span>
//                             <p>
//                                 {formatDate(booking.endDate) || "-"}
//                             </p>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="assign-photographer-modal-body">
//                     <form id="floatForm" onSubmit={handleSubmit} className="assign-photographer-form">



//                         {/* Photographer Dropdown (like customer) */}
//                         <div className="form-group" style={{ gridColumn: "span 2" }}>
//                             <label>Float Photographer *</label>

//                             <div className="user-dropdown" ref={photographerDropdownRef}>
//                                 <div className="dropdown-input-wrapper">
//                                     <input
//                                         type="text"
//                                         placeholder="Search Photographer by name or mobile..."
//                                         value={photographerSearch}
//                                         onChange={(e) => {
//                                             setPhotographerSearch(e.target.value);
//                                             setIsPhotographerDropdownOpen(true);
//                                         }}
//                                         onFocus={() => setIsPhotographerDropdownOpen(true)}
//                                     />
//                                     <span className="dropdown-arrow">▼</span>
//                                 </div>

//                                 {/* {isPhotographerDropdownOpen && (
//                                     <div className="assign-photographer-dropdown-list">
//                                         {loadingPhotographers ? (
//                                             <div className="dropdown-status">Loading photographers...</div>
//                                         ) : filteredPhotographers.length === 0 ? (
//                                             <div className="dropdown-empty">
//                                                 <p>No photographer found</p>
//                                                 <button
//                                                     type="button"
//                                                     className="btn-primary"
//                                                     onClick={() => {
//                                                         setIsPhotographerDropdownOpen(false);
//                                                         navigate("/photographer")
//                                                     }}
//                                                 >
//                                                     + Add New Photographer
//                                                 </button>
//                                             </div>
//                                         ) : (
//                                             filteredPhotographers.map((photographer) => (
//                                                 <div
//                                                     key={photographer._id}
//                                                     className={`assign-photographer-dropdown-item ${formData.photographerId === photographer._id ? "selected" : ""
//                                                         }`}
//                                                     onClick={() => {
//                                                         setFormData({
//                                                             ...formData,
//                                                             photographerId: photographer._id,
//                                                         });

//                                                         setPhotographerSearch(
//                                                             photographer.name || photographer.phone || photographer?.email);

//                                                         setIsPhotographerDropdownOpen(false);
//                                                     }}
//                                                 >

//                                                     <div className="user-name">{photographer.name}</div>
//                                                     <div className="user-mobile">
//                                                         {photographer.phone}
//                                                     </div>
//                                                     {photographer.email && (
//                                                         <div className="user-email">{photographer.email}</div>
//                                                     )}
//                                                     <hr className="my-toggle-text" />
//                                                 </div>
//                                             ))
//                                         )}
//                                     </div>
//                                 )} */}
//                                 {/* {isPhotographerDropdownOpen && ( */}
//                                 <div className="assign-photographer-dropdown-list">

//                                     {loadingPhotographers ? (
//                                         <div className="dropdown-status">Loading photographers...</div>
//                                     ) : filteredPhotographers.length === 0 ? (
//                                         <div className="dropdown-empty">
//                                             <p>No photographer found</p>
//                                             <button
//                                                 type="button"
//                                                 className="btn-primary"
//                                                 onClick={() => {
//                                                     setIsPhotographerDropdownOpen(false);
//                                                     navigate("/photographer");
//                                                 }}
//                                             >
//                                                 + Add New Photographer
//                                             </button>
//                                         </div>
//                                     ) : (

//                                         <table className="photographer-table">
//                                             <thead>
//                                                 <tr>
//                                                     <th>
//                                                         <div className="checkbox-sr-header">
//                                                             <input
//                                                                 type="checkbox"
//                                                                 onChange={handleSelectAll}
//                                                                 checked={selectAllChecked}
//                                                             />
//                                                             <span>Sr.</span>
//                                                         </div>
//                                                     </th>

//                                                     <th>Photographer Name</th>
//                                                     <th>Level</th>
//                                                     <th>Commission</th>
//                                                 </tr>
//                                             </thead>

//                                             <tbody>
//                                                 {filteredPhotographers.map((photographer, index) => {
//                                                     const isChecked = formData.photographerIds.includes(photographer._id);

//                                                     return (
//                                                         <tr key={photographer._id}>
//                                                             <td>
//                                                                 <div className="checkbox-sr-cell">
//                                                                    <input
//   type="checkbox"
//   checked={formData.photographerIds.includes(photographer._id)}
//   onChange={(e) => {
//     const checked = e.target.checked;
// console.log("Photographer:", photographer);   // 👈 ADD THIS
//     console.log("Photographer ID:", photographer._id); // 👈 ADD THIS

//     setFormData((prev) => ({
//       ...prev,
//       photographerIds: checked
//         ? [...prev.photographerIds, photographer._id]
//         : prev.photographerIds.filter((id) => id !== photographer._id),
//     }));
//   }}
// />
//                                                                     <span> {(page - 1) * LIMIT + index + 1}</span>
//                                                                 </div>
//                                                             </td>

//                                                             <td>{photographer.name || "-"}</td>
//                                                             <td>{photographer.level || "-"}</td>
//                                                             <td>{photographer.commissionPercentage || "-"}%</td>
//                                                         </tr>
//                                                     );
//                                                 })}
//                                             </tbody>
//                                         </table>


//                                     )}
//                                     {totalPages > 1 && (
//                                         <div className="pagination">
//                                             <button
//                                                 type="button"
//                                                 className="pagination-btn"
//                                                 disabled={page === 1}
//                                                 onClick={() => setPage(page - 1)}
//                                             >
//                                                 Prev
//                                             </button>

//                                             {getPageNumbers().map((p) => (
//                                                 <button
//                                                     type="button"
//                                                     key={p}
//                                                     className={`pagination-btn ${p === page ? "active" : ""}`}
//                                                     onClick={() => setPage(p)}
//                                                 >
//                                                     {p}
//                                                 </button>
//                                             ))}

//                                             <button
//                                                 type="button"
//                                                 className="pagination-btn"
//                                                 disabled={page === totalPages}
//                                                 onClick={() => setPage(page + 1)}
//                                             >
//                                                 Next
//                                             </button>
//                                         </div>
//                                     )}
//                                 </div>

//                             </div>

//                         </div>





//                     </form>
//                 </div>

//                 <div className="quote-modal-footer">
//                     <button className="btn-secondary" type="button"
//                         onClick={() => {
//                             resetForm();
//                             onClose();
//                         }}>
//                         Cancel
//                     </button>
//                     <button className="btn-primary" type="submit" form="floatForm">
//                         Send Photographer Request
//                     </button>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default FloatBookingModal;